export enum MenuType {
    DEFAULT = "default"
}

export enum PartnerType {
    TERRITORY = "territory",
    COMPANY = "company"
}
